import { Component, ElementRef, ViewChild, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';

import { Broker, BrokerSubscriber, Platform } from '@c4/core';
import { SysmanComponentBase, IOnBrokerConnectedInit } from '../sysman/sysman.component';
import { ConnectedDeviceService, NetworkService, VersionsService, LogService } from '../services';

@Component({
  selector: 'sysman-log-view',
  templateUrl: './sysman-log-view.component.html',
  styleUrls: ['./sysman-log-view.component.less']
})
export class SysmanLogViewComponent extends SysmanComponentBase implements OnInit, IOnBrokerConnectedInit {
  logName: string;
  displayLogName: string;
  logdata: string;
  logviewtype: number;
  tailLogSubscriber: BrokerSubscriber<any>;
  isError: boolean;
  errorMsg: string;
  notFoundErrorMsg: string = "This log file doesn't exist on the controller.";

  logviewtypes = [
    'Entire Log',
    'Tail Log'
  ];

  @ViewChild('logViewer') private logViewer: ElementRef;

  constructor(private router: Router, private route: ActivatedRoute,
    private store: Store<any>, private broker: Broker, private platform: Platform,
    private connectedDeviceService: ConnectedDeviceService,
    private versionsService: VersionsService, private logService: LogService,
    private _elementRef: ElementRef) {
    super(router, route, store, broker, platform, connectedDeviceService, versionsService);
    super.setBrokerInit(this.onBrokerConnectedInit); // method to call on broker init

    this.logviewtype = 0;
    this.setError();
  }

  ngOnInit() {
    super.OnInit();
  }

  ngOnDestroy() {
    console.log("in SysmanLogViewComponent ngOnDestroy()");
    super.destroy();
    this.logdata = "";
    this.logName = "";
    this.displayLogName = "";
    this.stopTailLog();
  }

  onBrokerConnectedInit() {
    this.logdata = "";

    this.subscriptions.push(
      this.route.queryParams.subscribe(params => {
        if (params['file']) {
          this.displayLogName = params['file'];;
          this.logName = params['file'];
          // need to create path relative to /var/log/
          //  /var/log/debug/director.log = ../debug/director.log
          //  /var/log/upmanlogs/upmand.log  ../upmanlogs/upmand.log"
//          this.logName = "..%2F" + this.logName.substring(this.logName.indexOf("/var/log/") + 9).replace("/", "%2F");
          this.logName = this.logName.substring(this.logName.indexOf("/var/log/") + 9);
          console.log("SysmanLogViewComponent onBrokerConnectedInit()", this.logName);
          this.getLogFile();
        }
        else {
          this.setError("Please choose a log file to view.");
        }
      }));
  }

  goBack() {
    this.router.navigate(["../../sysman/logging"], { relativeTo: this.route });
  }

  valueChangeLogViewType(event: any) {
    this.logviewtype = event;
    if (this.logviewtype == 0)
      this.onClickEntireLog();
    else
      this.onClickTailLog();
  }

  onClickEntireLog() {
    this.logdata = "";
    // unsubscribe tail
    this.stopTailLog();
    this.getLogFile();
  }

  onClickTailLog() {
    this.logdata = "";
    this.connectedDeviceService.setWorking(true);
    this.logService.tailLogFile(this.logName).then(
      (result: any) => {
        this.tailLogSubscriber = result;
        this.tailLogSubscriber.subscribe(data => {
          // console.log('onClickTailLog() subscription:', data); 
          this.logdata += data;
          this.setError();
          // need to wait 300ms for text area to populate before scrolling to the end
          setTimeout(() => { 
            this.connectedDeviceService.setWorking(false); 
            this.scrollToBottom(); 
          }, 300);
        },
          (err: any) => {
            this.connectedDeviceService.setWorking(false);
            this.setError(this.notFoundErrorMsg);
            console.log('onClickTailLog() error', err);
          }),
      (err: any) => {
          this.connectedDeviceService.setWorking(false);
          this.setError(this.notFoundErrorMsg);
          console.log('onClickTailLog() error', err);
          }
      });
  }

  private getLogFile() {
    this.connDevice.take(1).subscribe(conn => {
        this.connectedDeviceService.setWorking(true);
        this.logService.getLogFile(this.logName, conn.connectedDevice.address).then(
          (data: any) => {
            this.setError();
            this.logdata = data._body;
            // need to wait 300ms for text area to populate before scrolling to the end
            setTimeout(() => { 
              this.connectedDeviceService.setWorking(false);
              this.scrollToBottom(); 
            }, 300);
          },
          (err: any) => {
            console.error('getLogFile() 400 error: ', err);
            this.connectedDeviceService.setWorking(false);
            this.logdata = "";
            this.setError(this.notFoundErrorMsg);
            this.scrollToTop();
          });
    });
  }

  private stopTailLog() {
    if (this.tailLogSubscriber) {
      this.tailLogSubscriber.unsubscribe();
      this.tailLogSubscriber = null;
    }
  }

  private scrollToBottom(): void {
    try {
      this.logViewer.nativeElement.parentElement.scrollTop = this.logViewer.nativeElement.parentElement.scrollHeight;
    } catch (err) { }
  }

  private scrollToTop(): void {
    try {
      this.logViewer.nativeElement.parentElement.scrollTop = this.logViewer.nativeElement.parentElement.top;
    } catch (err) { }
  }

  private setError(msg?: string) {
    if (msg) {
      this.errorMsg = msg;
      this.isError = true;
    }
    else {
      this.errorMsg = "";
      this.isError = false;
    }
  }

  typeSelected(index: number) {
    this.valueChangeLogViewType(index);
  }

}



// WEBPACK FOOTER //
// ./~/@c4/sysman/src/app/sysman-log-view/sysman-log-view.component.ts